import { RPCConstants } from "../rocket/D3ETemplate";

export default class FileServiceClient {}
